import { render, staticRenderFns } from "./FullSecurityLayout.vue?vue&type=template&id=21cf1725&scoped=true"
import script from "./FullSecurityLayout.vue?vue&type=script&lang=js"
export * from "./FullSecurityLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21cf1725",
  null
  
)

export default component.exports